import {hashString} from '../utilities/strings'
import {Request, Response} from '../utilities/network';
import {generateHmacHeaders} from '../utilities/hmac';
import langstore from '../../system/i18n/translator.js';
import {openDB} from 'idb'
import {runInAction} from "mobx";

const dataRequest = async function (data) {

    let log = '\n';

    data = data || {};
    let params = data.params || {};
    //let namespace = this.config.paths.namespace + this.config.app.version;
    let namespace = this.fullNamespace;
    let url = data.url;
    let cacheID = data.cacheID ? String(`${namespace}_${data.cacheID}`) : String(`${namespace}_${hashString(url + JSON.stringify(params))}`);
    let cacheAge = data.cacheAge || 1000;
    let now = +new Date();
    let userToken = data.userToken || null;
    let result = {}
    let method = data.method || "POST";

    log += `Url: ${url}\n`;
    log += `Params: ${JSON.stringify(params)}\n`;

    // IndexedDB
    const dbPromise = await openDB(namespace, 2, {
        upgrade(db) {
            db.createObjectStore('networkdata');
        }
    });

    runInAction(() => {
        this.networkDBStore = dbPromise;
    });

    let tempData = await dbPromise.get('networkdata', cacheID);
    if (tempData) {
        tempData = JSON.parse(tempData)
    }


    // check if there is stored data
    // let tempData = JSON.parse(localStorage.getItem(cacheID)) || {};

    // if cache and cache is fresh
    if (tempData && tempData.data && tempData.timestamp && ((now - tempData.timestamp) < cacheAge)) {
        result = tempData.data;
        log += 'Source: cache\n';
        return result;
    }

    // if no cache or cache is too old
    else {
        try {
            log += 'Source: network\n';

            let requestBody = new Request({data: params});

            let headers = {"Content-Type": "application/json"};
            if (userToken !== null) {
                headers["x-access-token"] = userToken;
            }
            if (data.hmac) {
                const hmacHeaders = await generateHmacHeaders(this.config?.hmac?.sharedSecret || '');
                Object.assign(headers, hmacHeaders);
            }
            let request = {method: method, headers: headers};
            if (method !== 'GET') {
                request.body = JSON.stringify(requestBody);
            }
            let _response = await fetch(url, request);
            let response = await _response.json();
            let then = +new Date();
            result = new Response(response);

            log += `Time: ${String(then - now)} ms`;

            if (result.logout === false && result.status === 'OK') {
                try {
                    let d = JSON.stringify({
                        data: result,
                        timestamp: +new Date()
                    });
                    await dbPromise.put('networkdata', d, cacheID);
                } catch (e) {
                    this.log("Quota localstorage è piena", "WARNING");
                }
            }

            this.log(log, 'API');

            return result;

        } catch (e) {
            this.log(e, "WARNING");
        }

    }

}


// wrapper for network request with logout and cache reset
const dataLayer = async function (data) {

    let response = await this.dataRequest(data);

    if (response) {

        // logout management
        if (response.logout === true) {
            this.log((response && response.message ? response.message : "Consultare network per i dettagli"), "WARNING");

            // Durante il lock screen biometrico le chiamate di sfondo (es. pushNotificationInit)
            // non devono triggerare biometricSilentRefresh: l'OS ha un solo slot biometrico e
            // biometricSilentRefresh scipperebbe il prompt a biometricLogin, che non riceve
            // NotAllowedError e non chiama userAuth/init → app senza dati di sessione.
            if (this.biometricLockActive) {
                return;
            }

            // Silent refresh: se biometria attiva e non è già un retry, prova a rinnovare il token
            if (this.biometricEnabled && !data.isRetry) {
                const result = await this.biometricSilentRefresh();
                if (result.success) {
                    return await this.dataLayer({ ...data, userToken: this.userToken, isRetry: true });
                }

                // Qualsiasi fallimento del silent refresh → relock invece di logout diretto.
                // Evita che chiamate concorrenti in dataLayer, che condividono lo stesso
                // _refreshPromise via mutex, causino un logout involontario quando
                // biometricRelockRetry è già in corso.
                this.biometricRelock();
                return;
            }

            // Se il relock è attivo (es. retry di una chiamata dopo biometricSilentRefresh
            // che ha restituito un token poi rifiutato dal server), non fare logout:
            // lascia che l'utente gestisca tramite l'overlay.
            if (this.biometricRelockActive) {
                return;
            }

            // I really want to notify the user about an AUTH ERROR on logout?
            // this.notificationAdd(langstore.t("user_autherror", "Errore di autenticazione"), 'userformlogin', null, 'error');
            await this.userLogout();
            return;
        }

        // unmanaged status
        if (data.rawResponse === true) {
            return response;
        }
        // managed status
        else {
            if (response.status === 'ERROR') {
                // TODO REFACTOR: sometimes an error code is declared on statusCode and sometimes into message field. Must be normalized
                return await this.handleResponseErrors(response.statusCode || response.message);
            }

            return response;
        }


    } else {
        this.notificationAdd(langstore.t("user_servererror", "Errore server") + ': ' + response.message || 'undefined', 'userformlogin', 3000, 'error');
        this.log((response && response.message ? response.message : "Consultare network per i dettagli"), "ERRORE");

    }

}

const handleResponseErrors = async function (errorCode) {
    switch (errorCode) {
        case 'PASSWORD_EXPIRED':
            this.routeChange('/password-expired');
            break;
        case 'pim_video_academy_list_error':
            this.notificationAdd(langstore.t('pim_video_academy_list_error','Impossibile caricare la lista dei video'), 'pim_video_academy_list_error', 5000, 'error');
            break;
        case 'warranty_request_error':
            this.notificationAdd(langstore.t("warranty_request_error"), 'warranty_error', 5000, 'error');
            break;
        case 'warranty_notification_error':
            this.notificationAdd(langstore.t("warranty_notification_error"), 'warranty_error', 5000, 'error');
            break;
        case 'warranty_update_error':
            this.notificationAdd(langstore.t("warranty_update_error"), 'warranty_error', 5000, 'error');
            break;
        case 'USER_OR_PASSWORD_NOT_VALID':
        case 'INVALID_USER_SERVICE':
            this.notificationAdd(langstore.t("user_or_password_not_valid_error"), 'user_error', 5000, 'error');
            break;
        case 'BLOCKED_USER':
        case 'BLOCKED_USER_NOTIFICATION':
            this.notificationAdd(langstore.t("blocked_user"), 'user_error', 10000, 'error');
            break;
        case 'PASSWORD_PWNED':
            this.notificationAdd(langstore.t("password_pwned"), 'user_error', 10000, 'error');
            break;
        case 'EPARAM':
        case 'VALIDATION_ERROR':
            this.notificationAdd(langstore.t('data_validation_error', 'Alcuni dati non sono validi. Per favore controlla e riprova.'), 'validation_error', 10000, 'error');
            break;
        case 'ORDER_NOT_FOUND':
            this.notificationAdd(langstore.t('order_not_found', 'Numero ordine non valido'), 'validation_error', 10000, 'error');
            break;
        case 'DAMAGE_REPORT_NOT_ENTERED':
            this.notificationAdd(langstore.t('damage_report_not_entered', 'A causa di un errore la segnalazione non è stata inserita'), 'insert_error', 10000, 'error');
            break;
        case 'DAMAGE_FULL_REPORT_NOT_ENTERED':
            this.notificationAdd(langstore.t('damage_full_report_not_entered', 'A causa di un errore la segnalazione non è stata inviata'), 'insert_error', 10000, 'error');
            break;
        case 'REQUEST_NOT_VALID':
            this.notificationAdd(langstore.t('request_not_valid', 'La richiesta non è valida'), 'insert_error', 10000, 'error');
            break;
        default:
            this.notificationAdd(langstore.t("user_apperror", "Errore") + ': ' + errorCode || 'undefined', 'userformlogin', 3000, 'error');
            break;
    }

    this.loadingRemove();
    return errorCode;
}

export {
    dataLayer,
    dataRequest,
    handleResponseErrors
}
